<template>
  <main>
    <div class="py-4 container-fluid">
      <div class="row">

        <div class="col-md-12">
          <MetaSection :title="($route.params?.id ? '' : 'Tambah ') +'Assignment KPI'">
            <div class="text-right">
              <router-link :to="{ name: 'Assignment KPI Pegawai' }">
                <button class="btn btn-secondary">
                  Kembali
                </button>
              </router-link>
            </div>
          </MetaSection>
        </div>

        <div class="col-md-12">
          <div
            v-if="step === 1 && !$route.params?.id"
            class="d-flex flex-column align-items-center mx-auto"
            style="width: 600px;"
          >
            <cards class="mb-4" :withmin="false">
              <h4 class="font-weight-bolder text-lg">Informasi Pegawai</h4>
              <p class="text-center px-6">Dapatkan informasi data diri pegawai dengan memasukkan kata kunci berdasarkan nama atau NIP.</p>

              <form-group label="Cari Pegawai" class="w-100 mb-0">
                <div class="form-group">
                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="Silahkan cari pegawai atau nip disni..." v-model="employee_keyword" @keyup="searchKeyword()">
                    <span class="input-group-text">
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </form-group>
              
              <p v-if="loading_employees" class="text-center">Loading...</p>
              
              <!-- <table class="table border rounded-2 table-hover" v-if="keyword.length > 0"> -->
              <table class="table border rounded-2 table-hover" v-else-if="!loading_employees && employees_list.length > 0">
                <thead>
                  <tr>                  
                    <th class="text-secondary text-xs">Nama</th>
                    <th class="text-secondary text-xs">Posisi</th>
                    <th class="text-secondary text-xs">Jabatan</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr>
                    <td colspan="3" class="text-center"></td>
                  </tr> -->
                  <tr v-for="(item, index) in employees_list" :key="index" class="cursor-pointer" @click="chooseEmployee(item)">
                    <td class="font-weight-bolder">{{ item?.name || '-' }}</td>
                    <td>{{ item?.position || '-' }}</td>
                    <td>{{ item?.jabatan?.name || '-' }}</td>
                  </tr>
                </tbody>
              </table>

              <p v-else-if="!loading_employees && employee_keyword.length > 0 && employees_list.length === 0" class="text-center">
                Pegawai tidak ditemukan.
              </p>
            </cards>

          </div>

          <!-- <template v-else-if="step === 2"> -->
          <template v-else>
            <cards class="mb-4" :withmin="false">
              <FieldsetComponent
                title="Informasi Pegawai"
                title-class="text-md"
                description="Data diri pegawai yang sudah dipilih untuk di assign KPI wajib dan KPI tambahan."
              >
                <div>
                  <h4 class="text-lg">Data Pegawai Terpilih</h4>
                  
                  <div class="border rounded-2 p-4 mt-4 d-flex gap-4">
                    <div class="bg-secondary rounded-2" style="width: 92px; height: 92px; "></div>
                    
                    <div class="d-flex flex-column gap-3 w-75">
                      <div class="row ">
                        <div class="col d-flex flex-column">
                          <span class="text-secondary text-xs">Nama</span>
                          <span>{{ employee_selected?.name || '-' }}</span>
                        </div>
                        <div class="col d-flex flex-column">
                          <span class="text-secondary text-xs">Jabatan</span>
                          <span>{{ employee_selected?.jabatan?.name || '-' }}</span>
                        </div>
                      </div>
                      
                      <div class="row">
                        <div class="col d-flex flex-column">
                          <span class="text-secondary text-xs">NIP</span>
                          <span>{{ employee_selected?.nip || '-' }}</span>
                        </div>
                        <div class="col d-flex flex-column">
                          <span class="text-secondary text-xs">Unit Kerja</span>
                          <span>{{ employee_selected?.unitkerja?.name || '-' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="!$route.params?.id" class="mt-4 d-flex justify-content-end">
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="nextStep(1)"
                    >
                      Hapus
                    </button>
                  </div>
                </div>
              </FieldsetComponent>
            </cards>
            
            <cards class="card--tabs mb-4" :withmin="false" :p="0">
              <tabbed-pane
                :tabs="{ 'Daftar Aspek Penilaian Kinerja': true, 'Aspek Penilaian Kinerja Tambahan': false }"
              >

                <div class="tab-pane fade show active p-4 pt-0" id="pills-daftar-aspek-penilaian-kinerja" role="tabpanel"
                  aria-labelledby="pills-daftar-aspek-penilaian-kinerja-tab">
                  <FieldsetComponent
                    title="Aspek Penilaian Kinerja"
                    title-class="text-md"
                    description="Daftar aspek penilaian kinerja KPI yang sudah ditentukan sesuai kontrak kerja karyawan sesuai jabatan dan unit kerja masing-masing. Dalam daftar ini, supervisor hanya dapat mengubah informasi target dan bobot aspek penilaian kinerja."
                  >
                    <div>
                      <div class="mb-5">
                        <h4 class="text-lg">Periode</h4>
                        <FormGroup class="m-0 w-100">
                          <select class="form-control" v-model="periode_id" :disabled="$route.params?.id">
                            <option value="">- Pilih Periode -</option>
                            <option v-for="(item, index) in list_periode" :key="index" :value="item.id">{{ item.name }}</option>
                          </select>
                        </FormGroup>
                      </div>

                      <template v-for="(item, i) in kpi" :key="i">
                        <div class="d-flex justify-content-between items-center">
                          <h4 class="text-lg">{{ item?.title || '-' }}</h4>
                          <span>Total Bobot <strong :class="{ 'text-danger': sumBobotSubKpi(item?.child || []) > 100 }">{{ sumBobotSubKpi(item?.child || []) }}</strong></span>
                        </div>
                        
                        <table class="table border rounded-2 rounded-top mt-4">
                          <thead>
                            <tr style="background-color: #E4E9EF;">
                              <th class="text-secondary text-xs" style="width:45%">Sub KPI</th>
                              <th class="text-secondary text-xs">Target</th>
                              <th class="text-secondary text-xs">Satuan</th>
                              <th class="text-secondary text-xs" style="width:120px">Bobot</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(sub, index) in item?.child" :key="index">
                              <td class="font-weight-bolder p-4">{{ sub?.title || '-' }}</td>
                              <td class="py-4">
                                <input v-if="!$route.params?.id" type="number" class="form-control w-100" placeholder="Target" v-model="kpi[i].child[index].target" required>
                                <template v-else>
                                  <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                      }).format(sub?.target || '0')
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        minimumFractionDigits: 0,
                                      }).format(sub?.target || '0')
                                    }} 
                                    <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '-' }}</span>
                                  </span>
                                </template>

                                <!-- <form-group class="col-2 mb-4" label="Bobot">
                                  <div class="input-group">
                                    <input type="number" class="form-control" placeholder="Bobot" aria-label="Bobot" aria-describedby="basic-addon2" step=".01" v-model="kpi_selected.child[i].bobot" required>
                                    <span class="input-group-text" id="basic-addon2">%</span>
                                  </div>
                                </form-group> -->
                              </td>
                              <td class="py-4 text-capitalize">
                                <!-- <select v-if="!$route.params?.id" class="form-select text-capitalize" aria-label="Satuan Target" v-model="kpi[i].child[index].satuan" required>
                                  <option value="">- Pilih Satuan Target -</option>
                                  <option v-for="item in satuan_target" :key="item" :value="item">{{ item }}</option>
                                </select> -->
                                <span class="badge badge-secondary badge--full-table text-capitalize">{{ sub?.satuan || '-' }}</span>
                                <!-- <span class="badge badge-secondary badge--full-table text-capitalize">{{ getSatuan(sub?.satuan) || '-' }}</span> -->
                              </td>
                              <td class="py-4">
                                <div class="input-group w-100" v-if="!$route.params?.id">
                                  <input type="number" class="form-control" placeholder="Bobot" aria-label="Bobot" :aria-describedby="'basic-addon2-' + i + '-' + index" step=".01" v-model="kpi[i].child[index].bobot" required>
                                  <span class="input-group-text" :id="'basic-addon2-' + i + '-' + index">%</span>
                                </div>
                                <span v-else>{{ sub?.bobot ? sub.bobot +'%' : '-' }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <div class="mt-4 d-flex justify-content-end">
                          <button
                            v-if="!$route.params?.id"
                            @click="chooseKpi(item)"
                            :disabled="!item?.child || item?.child?.[0] === null"
                            type="button"
                            class="btn btn-outline-secondary"
                            data-bs-toggle="modal"
                            data-bs-target="#kpiModal"
                          >Ubah</button>
                        </div> -->

                        <div v-if="(i+1) !== kpi.length" class="mb-6"></div>
                      </template>

                      <template v-for="(item, i) in detail_kpi_master" :key="i">
                        <div class="d-flex justify-content-between items-center">
                          <h4 class="text-lg">{{ item?.title || '-' }}</h4>
                          <span>Total Bobot <strong :class="{ 'text-danger': sumBobotSubKpi(item?.kpi || []) > 100 }">{{ sumBobotSubKpi(item?.kpi || []) }}</strong></span>
                        </div>
                        
                        <table class="table border rounded-2 rounded-top mt-4">
                          <thead>
                            <tr style="background-color: #E4E9EF;">
                              <th class="text-secondary text-xs">Sub KPI</th>
                              <th class="text-secondary text-xs" width="140px">Target</th>
                              <th class="text-secondary text-xs" width="140px">Satuan</th>
                              <th class="text-secondary text-xs" width="140px">Bobot</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(sub, index) in item?.kpi" :key="index">
                              <td class="font-weight-bolder p-4">{{ sub?.title || '-' }}</td>
                              <td class="py-4">
                                <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(sub?.target || '0')
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      minimumFractionDigits: 0,
                                    }).format(sub?.target || '0')
                                  }} 
                                  <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '-' }}</span>
                                </span>
                              </td>
                              <td class="py-4 text-capitalize">{{ sub?.satuan || '-' }}</td>
                              <!-- <td class="py-4 text-capitalize">{{ getSatuan(sub?.satuan) || '-' }}</td> -->
                              <td class="py-4">{{ sub?.bobot ? sub.bobot +'%' : '-' }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <hr v-if="(i+1) !== detail_kpi_master.length" class="mt-4 mb-4" />
                      </template>
                    </div>
                  </FieldsetComponent>

                  <!-- Modal -->
                  <div class="modal fade" id="kpiModal" ref="kpiModal" tabindex="-1" aria-labelledby="kpiModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-xl">
                      <form @submit.prevent="updateSubKpi" class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="kpiModalLabel">{{ kpi_selected?.title || '-' }}</h5>
                          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <i class="fa fa-times cursor-pointer" aria-hidden="true"></i>
                          </button> -->

                          <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                            <font-awesome-icon icon="fa-solid fa-times" />
                          </span>
                        </div>
                        <div class="modal-body">
                          <div
                            v-for="(item, i) in kpi_selected?.child"
                            :key="item"
                            class="row"
                          >
                            <form-group class="form-group col-5" label="Nama Aspek">
                              <input type="text" class="form-control" placeholder="Nama aspek" :value="item?.title || '-'" readonly>
                            </form-group>
                            <form-group class="form-group col-3" label="Target">
                              <input type="number" class="form-control" placeholder="Target" v-model="kpi_selected.child[i].target" required>
                            </form-group>
                            <form-group class="form-group col-2" label="Satuan Target">
                              <select class="form-select text-capitalize" aria-label="Satuan Target" v-model="kpi_selected.child[i].satuan" required>
                                <option value="">- Pilih Satuan Target -</option>
                                <!-- <option v-for="item in satuan_target" :key="item.value" :value="item.value">{{ item.label }}</option> -->
                                <option v-for="item in list_satuan_target" :key="item.id" :value="item.nama_satuan">{{ item.nama_satuan }}</option>
                              </select>
                            </form-group>

                            <form-group class="col-2 mb-4" label="Bobot">
                              <div class="input-group">
                                <input type="number" class="form-control" placeholder="Bobot" aria-label="Bobot" :aria-describedby="'basic-addon2-' + i" step=".01" v-model="kpi_selected.child[i].bobot" required>
                                <span class="input-group-text" :id="'basic-addon2-' + i">%</span>
                              </div>
                            </form-group>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" ref="kpiModalClose">Batalkan</button>
                          <button type="submit" class="btn btn-secondary">Simpan</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div class="tab-pane fade show p-4 pt-0" id="pills-aspek-penilaian-kinerja-tambahan" role="tabpanel"
                  aria-labelledby="pills-aspek-penilaian-kinerja-tambahan-tab">

                  <div v-if="!$route.params?.id && !accept_additional_aspek" class="mb-5 p-4" style="background-color: #F4F9FF;">
                    <h4>Perhatian</h4>
                    <p>Data aspek penilaian kinerja yang ditambahkan atau di assign khusus untuk pegawai tertentu, tidak akan masuk ke dalam laporan KPI Gabungan, hanya akan masuk di laporan detail masing-masing pegawai.</p>
                    <div class="mt-4 mb-0 d-flex justify-content-end">
                      <button type="button" class="btn btn-outline-secondary" @click="accept_additional_aspek = !accept_additional_aspek">Saya Mengerti</button>
                    </div>
                  </div>

                  <ArgonAlert
                    v-if="note"
                    title="Catatan"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ note || '-' }}</p>
                  </ArgonAlert>

                  <FieldsetComponent
                    title="Aspek Penilaian Kinerja Tambahan"
                    title-class="text-md"
                    description="Supervisor dapat menambahkan aspek penilaian kinerja baru, di luar aspek penilaian kinerja wajib untuk masing-masing pegawai. Ketika menambahkan aspek penilaian kinerja tambahan, perlu persetujuan Admin Pusat dari HCL."
                  >
                    <template v-if="!$route.params?.id || status === 'reject_by_admin'">
                      <h4 class="text-lg">Tambah Kategori KPI dan aspek Penilaian Kinerja Tambahan</h4>
                      <p class="text-sm">Isi kolom dibawah dengan kategori KPI</p>
                      <form class="row" @submit.prevent="addKpiTemporary()">
                        <div class="form-group col-10">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Contoh “Kredit”"
                            v-model="input_aspek_kpi"
                            :disabled="additional_aspek_temporary !== null"
                            required
                          />
                        </div>
                        <button
                          type="submit"
                          class="btn btn-secondary col-2"
                          :disabled="additional_aspek_temporary !== null"
                        >
                          Tambah
                        </button>
                      </form>
                      
                      <template v-if="additional_aspek_temporary !== null">
                        <!-- <pre>{{ additional_aspek_temporary }}</pre> -->
                        <hr />

                        <h4 class="text-lg">Daftar Kategori KPI dan Aspek Penilaian Kinerja</h4>
                        <div class="border rounded-2 p-4">
                          <form @submit.prevent="processKpiTemporary()">
                            <label for="" class="form-label text-sm">Kategori</label>
                            <div class="row">
                              <div class="form-group col-8">
                                <input type="text" class="form-control" placeholder="Contoh “Kredit”" v-model="additional_aspek_temporary.title" required>
                              </div>
                              <div class="d-flex gap-2 col-4">
                                <button type="submit" class="btn btn-secondary">Simpan</button>
                                <button type="button" class="btn btn-outline-secondary" @click="deleteKpiTemporary()">Hapus</button>
                              </div>
                            </div>

                            <div class="form-group">
                              <label for="" class="form-label text-sm">Perspektif</label>
                              <select class="form-select text-capitalize" aria-label="Satuan Target" v-model="additional_aspek_temporary.perspektif" required>
                                <option value="">Silahkan Pilih Perspektif</option>
                                <option v-for="item in perspektif_list" :key="item" :value="item" >{{ item }}</option>
                              </select>
                            </div>
                            
                            <div class="border rounded-2 p-4">
                              <div class="d-flex flex-column align-items-center">

                                <h4 class="text-lg">Tambahkan Aspek penilaian kinerja</h4>
                                <h4 class="text-lg">KPI Tambahan -  Dana pihak ketiga</h4>
                                <p>Kinerja terdiri dari nama target, jumlah target,  satuan target, bobot, nilai </p>
                              </div>
                              <div class="d-flex gap-4">
                                <button type="button" class="btn btn-outline-secondary w-100 mb-0" data-bs-toggle="modal" data-bs-target="#createAspekModal">Buat Aspek Penilaian Baru</button>
                                <button type="button" class="btn btn-secondary w-100 mb-0" data-bs-toggle="modal" data-bs-target="#searchAspekModal" @click="modalSearchAspek(true)">Cari di Daftar Aspek Penilaian </button>
                              </div>
                            </div>

                            <template v-if="additional_aspek_temporary.category.length > 0">
                              <hr class=" mt-4" />
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th class="text-secondary text-xs" style="width: 30%;">Sub KPI</th>
                                    <th class="text-secondary text-xs" style="width: 250px;">Target</th>
                                    <th class="text-secondary text-xs" >Satuan</th>
                                    <th class="text-secondary text-xs" width="120px">Bobot</th>
                                    <th class="text-secondary text-xs"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(item, index) in additional_aspek_temporary.category"
                                    :key="item"
                                  >
                                    <td>{{ item.nama_aspek_kpi }}</td>
                                    <td>
                                      <!-- <span v-if="item?.satuan?.toLowerCase() === 'rupiah'">
                                        {{
                                          new Intl.NumberFormat('id-ID', {
                                            style: 'currency',
                                            currency: 'IDR',
                                            minimumFractionDigits: 0,
                                          }).format(item?.target || '0')
                                        }}
                                      </span>
                                      <span v-else>
                                        {{
                                          new Intl.NumberFormat('id-ID', {
                                            minimumFractionDigits: 0,
                                          }).format(item?.target || '0')
                                        }} 
                                        <span class="text-capitalize">{{ (item?.satuan?.toLowerCase() === 'persen' ? '%' : item?.satuan) || '-' }}</span>
                                      </span> -->
                                      <input
                                        v-model="additional_aspek_temporary.category[index].target"
                                        type="number"
                                        class="form-control w-100"
                                        placeholder="Tulis target disini..."
                                        required
                                      />
                                    </td>
                                    <td class="py-2 text-capitalize">
                                      <span class="badge badge-secondary badge--full-table text-capitalize">{{ item?.satuan || '-' }}</span>
                                      <!-- <span class="badge badge-secondary badge--full-table text-capitalize">{{ getSatuan(item?.satuan) || '-' }}</span> -->
                                    </td>
                                    <!-- <td class="py-2 text-capitalize">{{ item?.satuan || '-' }}</td> -->
                                    <!-- <td class="py-2">{{ item.bobot }}%</td> -->
                                    <td>
                                      <div class="input-group">
                                        <input
                                          v-model="additional_aspek_temporary.category[index].bobot"
                                          type="number"
                                          class="form-control"
                                          placeholder="Tulis bobot disini..."
                                          required
                                          step="0.01"
                                        />
                                        <span class="input-group-text" :id="'basic-addon2-add-' + index">%</span>
                                      </div>
                                    </td>
                                    <td class="py-2">
                                      <div class="d-flex align-items-center gap-1">
                                        <!-- <button type="button" class="btn-action btn-action--icon btn-action--secondary">
                                          <font-awesome-icon icon="fa-solid fa-pen" />
                                        </button> -->
                                        <button type="button" class="btn-action btn-action--icon btn-action--delete" @click="deleteCategoryKpiTemporary(index)">
                                          <font-awesome-icon icon="fa-solid fa-trash" />
                                        </button>

                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </template>
                          </form>

                          <!-- Modal create aspek -->
                          <div class="modal fade" id="createAspekModal" tabindex="-1" aria-labelledby="createAspekModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-xl">
                              <form class="modal-content" @submit.prevent="addNewAspek()">
                                <div class="modal-header">
                                  <h5 class="modal-title" id="createAspekModalLabel">Buat Aspek Penilaian Baru ehe</h5>
                                  <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                                    <font-awesome-icon icon="fa-solid fa-times" />
                                  </span>
                                </div>
                                <div class="modal-body">
                                  <h4 class="text-lg">Nama Aspek KPI</h4>
                                  <p>Contoh “Nominal Transaksi Luar Negeri”</p>
                                  <input
                                    v-model="new_aspek.nama_aspek_kpi"
                                    type="text"
                                    class="form-control w-100"
                                    placeholder="Silakan tulis nama aspek kpi disini..."
                                    required
                                  >

                                    <!-- v-for="item in 5" -->
                                    <!-- v-for="(item, index) in Object.keys(new_aspek.aspekkinerja)" -->
                                  <div
                                    v-for="(item) in 5"
                                    :key="item"
                                    class="border rounded-2 p-2 mt-4"
                                  >
                                    <h4 class="text-lg">Nilai {{ item }}</h4>
                                    <div class="row">
                                      <div class="col-6">
                                        <p>Nilai minimal</p>
                                        <div class="row w-100">
                                          <form-group
                                            label="Operator"
                                            class="form-group col-6"
                                            invalidmsg="Range tidak valid"
                                          >
                                            <select
                                              v-model="this.new_aspek.aspekkinerja['nilai'+ item +'_min_operator']"
                                              class="form-select"
                                              :class="{ 'is-invalid': this['error_aspek_'+ item] }"
                                              required
                                              @change="validateAspek(item)"
                                            >
                                              <option value="<">
                                                <span>&#60;</span>
                                              </option>
                                              <option value=">">
                                                <span>&#62;</span>
                                              </option>
                                              <option value="<=">
                                                <span>&#60;</span>
                                                <span>&#61;</span>
                                              </option>
                                              <option value=">=">
                                                <span>&#62;</span>
                                                <span>&#61;</span>
                                              </option>
                                            </select>
                                          </form-group>

                                          <form-group
                                            label="Angka"
                                            class="form-group col-6"
                                            invalidmsg="Range tidak valid"
                                          >
                                            <input
                                              type="number"
                                              class="form-control"
                                              placeholder="Contoh '80'"
                                              v-model="this.new_aspek.aspekkinerja['nilai'+ item +'_min']"
                                              required
                                              @change="validateAspek(item)"
                                              step="0.01"
                                              :class="{ 'is-invalid': this['error_aspek_'+ item] }"
                                              min="0"
                                            />
                                          </form-group>
                                        </div>
                                      </div>

                                      <!-- <div class="col-2">
                                        <form-group
                                          label=""
                                          class="form-group"
                                        >
                                        <p class="mt-6">(Nilai range X)</p>
                                        </form-group>
                                      </div> -->

                                      <div class="col-6">
                                        <p>Nilai maksimal</p>
                                        <div class="row w-100">
                                          <form-group
                                            class="form-group col-6"
                                            label="Operator"
                                            invalidmsg="Range tidak valid"
                                          >
                                            <select
                                              v-model="this.new_aspek.aspekkinerja['nilai'+ item +'_max_operator']"
                                              class="form-select"
                                              :class="{ 'is-invalid': this['error_aspek_'+ item] }"
                                              required
                                              @change="validateAspek(item)"
                                            >
                                              <option value="<">
                                                <span>&#60;</span>
                                              </option>
                                              <option value=">">
                                                <span>&#62;</span>
                                              </option>
                                              <option value="<=">
                                                <span>&#60;</span>
                                                <span>&#61;</span>
                                              </option>
                                              <option value=">=">
                                                <span>&#62;</span>
                                                <span>&#61;</span>
                                              </option>
                                            </select>
                                          </form-group>

                                          <form-group
                                            label="Angka"
                                            class="form-group col-6"
                                            invalidmsg="Range tidak valid"
                                          >
                                            <input
                                              type="number"
                                              class="form-control"
                                              placeholder="Contoh '80'"
                                              v-model="this.new_aspek.aspekkinerja['nilai'+ item +'_max']"
                                              required
                                              step="0.01"
                                              @change="validateAspek(item)"
                                              :class="{ 'is-invalid': this['error_aspek_'+ item] }"
                                              min="0"
                                            />
                                          </form-group>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <h4 class="text-lg mt-5">Aspek Kinerja</h4>
                                  <div class="row w-100">
                                    <form-group class="form-group col-4" label="Target">
                                      <input
                                        v-model="new_aspek.target"
                                        type="number"
                                        class="form-control"
                                        placeholder="Contoh 200000"
                                        required
                                      >
                                    </form-group>

                                    <form-group class="form-group col-4" label="Satuan Target">
                                      <select class="form-select text-capitalize" aria-label="Satuan Target" v-model="new_aspek.satuan" required>
                                        <option value="">- Pilih Satuan Target -</option>
                                        <!-- <option v-for="item in satuan_target" :key="item.value" :value="item.value">{{ item.label }}</option> -->
                                        <option v-for="item in list_satuan_target" :key="item.id" :value="item.nama_satuan">{{ item.nama_satuan }}</option>
                                      </select>
                                    </form-group>

                                    <form-group class="form-group col-4" label="Bobot">
                                      <div class="input-group">
                                        <input
                                          v-model="new_aspek.bobot"
                                          type="number"
                                          class="form-control"
                                          placeholder="0.00"
                                          step=".01"
                                          required
                                        >
                                        <span class="input-group-text">%</span>
                                      </div>
                                    </form-group>
                                  </div>

                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" ref="closeModalAddNewAspek">Batalkan</button>
                                  <button type="submit" class="btn btn-secondary">Simpan</button>
                                </div>
                              </form>
                            </div>
                          </div>

                          <!-- Modal search aspek -->
                          <div class="modal fade" id="searchAspekModal" tabindex="-1" aria-labelledby="searchAspekModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-xl">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h5 class="modal-title" id="searchAspekModalLabel">Cari Daftar Aspek Kinerja</h5>
                                  <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                                    <font-awesome-icon icon="fa-solid fa-times" />
                                  </span>
                                </div>
                                <div class="modal-body">
                                  <div class="d-flex gap-2">
                                    <form-group class="col-6">
                                      <div class="input-group">
                                        <input
                                          type="text"
                                          class="form-control"
                                          placeholder="Cari aspek kinerja disini"
                                          v-model="additional_aspek_keyword"
                                          @keyup="searchKeywordAdditionalAspek()"
                                        >
                                        <span class="input-group-text">
                                          <i class="fas fa-search" aria-hidden="true"></i>
                                        </span>
                                      </div>
                                    </form-group>
                                    
                                    <FormGroup  class="col-6">
                                      <!-- <select @change="getData()" class="form-control" v-model="params.unitkerja_id"> -->
                                      <select class="form-control" v-model="additional_aspek_unitkerja_id" @change="getListAdditionalAspek()">
                                        <option value="">Semua Unit Kerja</option>
                                        <option v-for="(item, index) in additional_aspek_list_unit_kerja" :key="index" :value="item.id">{{ item.name }}</option>
                                      </select>
                                    </FormGroup>

                                  </div>

                                  <!-- <pre>{{ additional_aspek_list }}</pre> -->
                                  <table class="table">
                                    <thead>
                                      <tr>
                                        <th
                                          v-for="item in thead"
                                          :key="item"
                                          class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                                        >
                                          {{ item }}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <template v-if="additional_aspek_list.length > 0">
                                        <tr
                                          v-for="(item, index) in additional_aspek_list"
                                          :key="index"
                                          class="cursor-pointer"
                                          @click="chooseSearchAspek(item)"
                                        >
                                          <td class="pt-3">
                                            <div class="form-check">
                                              <input class="form-check-input" type="checkbox" :value="item" :id="'flexCheckDefault-'+ index" v-model="additional_aspek_selected" readonly>
                                              <label class="form-check-label" :for="'flexCheckDefault-'+ index">
                                                {{ item?.title || '-' }}
                                              </label>
                                            </div>
                                          </td>
                                          <td class="pt-3">
                                            <span v-if="item?.satuan?.toLowerCase() === 'rupiah'">
                                              {{
                                                new Intl.NumberFormat('id-ID', {
                                                  style: 'currency',
                                                  currency: 'IDR',
                                                  minimumFractionDigits: 0,
                                                }).format(item?.target || '0')
                                              }}
                                            </span>
                                            <span v-else>
                                              {{
                                                new Intl.NumberFormat('id-ID', {
                                                  minimumFractionDigits: 0,
                                                }).format(item?.target || '0')
                                              }} 
                                              <span class="text-capitalize">{{ (item?.satuan?.toLowerCase() === 'persen' ? '%' : item?.satuan) || '-' }}</span>
                                            </span>
                                          </td>
                                          <td class="pt-3 text-capitalize">{{ item?.satuan || '-' }}</td>
                                          <!-- <td class="pt-3 text-capitalize">{{ getSatuan(item?.satuan) || '-' }}</td> -->
                                          <td class="pt-3">{{ item?.bobot || '-' }}%</td>
                                        </tr>
                                      </template>

                                      <tr v-if="additional_aspek_loading || additional_aspek_list.length === 0">
                                        <td :colspan="thead.length" class="text-center p-4">
                                          <span v-if="additional_aspek_loading">Loading...</span>
                                          <span v-if="!additional_aspek_loading && additional_aspek_list.length === 0">Data tidak ditemukan</span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Batalkan</button>
                                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="addSearchAspek()">Simpan</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>

                      <!-- Modal edit aspek -->
                      <div class="modal fade" id="editAspekModal" tabindex="-1" aria-labelledby="editAspekModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-xl">
                          <!-- <form class="modal-content" @submit.prevent="addNewAspek()"> -->
                          <form class="modal-content" @submit.prevent="updatEditAspek()">
                            <div class="modal-header">
                              <h5 class="modal-title" id="editAspekModalLabel">Edit Aspek Penilaian</h5>
                              <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                                <font-awesome-icon icon="fa-solid fa-times" />
                              </span>
                            </div>
                            <div class="modal-body">
                              <h4 class="text-lg">Nama Aspek KPI</h4>
                              <p>Contoh “Nominal Transaksi Luar Negeri”</p>
                              <input
                                v-model="edit_aspek.nama_aspek_kpi"
                                type="text"
                                class="form-control w-100"
                                placeholder="Silakan tulis nama aspek kpi disini..."
                                required
                                :readonly="this.is_edit_aspek_saved"
                              >

                                <!-- v-for="item in 5" -->
                                <!-- v-for="(item, index) in Object.keys(edit_aspek.aspekkinerja)" -->
                              <div
                                v-for="(item) in 5"
                                :key="item"
                                class="border rounded-2 p-2 mt-4"
                              >
                                <h4 class="text-lg">Nilai {{ item }}</h4>
                                <div class="row">
                                  <div class="col-6">
                                    <p>Nilai minimal</p>
                                    <div class="row w-100">
                                      <form-group
                                        label="Operator"
                                        class="form-group col-6"
                                        invalidmsg="Range tidak valid"
                                      >
                                        <select
                                          v-model="this.edit_aspek.aspekkinerja['nilai'+ item +'_min_operator']"
                                          class="form-select"
                                          :class="{ 'is-invalid': this['error_aspek_'+ item] }"
                                          required
                                          @change="validateEditAspek(item)"
                                        >
                                          <option value="<">
                                            <span>&#60;</span>
                                          </option>
                                          <option value=">">
                                            <span>&#62;</span>
                                          </option>
                                          <option value="<=">
                                            <span>&#60;</span>
                                            <span>&#61;</span>
                                          </option>
                                          <option value=">=">
                                            <span>&#62;</span>
                                            <span>&#61;</span>
                                          </option>
                                        </select>
                                      </form-group>

                                      <form-group
                                        label="Angka"
                                        class="form-group col-6"
                                        invalidmsg="Range tidak valid"
                                      >
                                        <input
                                          type="number"
                                          class="form-control"
                                          placeholder="Contoh '80'"
                                          v-model="this.edit_aspek.aspekkinerja['nilai'+ item +'_min']"
                                          required
                                          @change="validateEditAspek(item)"
                                          step="0.01"
                                          :class="{ 'is-invalid': this['error_aspek_'+ item] }"
                                          min="0"
                                        />
                                      </form-group>
                                    </div>
                                  </div>

                                  <!-- <div class="col-2">
                                    <form-group
                                      label=""
                                      class="form-group"
                                    >
                                    <p class="mt-6">(Nilai range X)</p>
                                    </form-group>
                                  </div> -->

                                  <div class="col-6">
                                    <p>Nilai maksimal</p>
                                    <div class="row w-100">
                                      <form-group
                                        class="form-group col-6"
                                        label="Operator"
                                        invalidmsg="Range tidak valid"
                                      >
                                        <select
                                          v-model="this.edit_aspek.aspekkinerja['nilai'+ item +'_max_operator']"
                                          class="form-select"
                                          :class="{ 'is-invalid': this['error_aspek_'+ item] }"
                                          required
                                          @change="validateEditAspek(item)"
                                        >
                                          <option value="<">
                                            <span>&#60;</span>
                                          </option>
                                          <option value=">">
                                            <span>&#62;</span>
                                          </option>
                                          <option value="<=">
                                            <span>&#60;</span>
                                            <span>&#61;</span>
                                          </option>
                                          <option value=">=">
                                            <span>&#62;</span>
                                            <span>&#61;</span>
                                          </option>
                                        </select>
                                      </form-group>

                                      <form-group
                                        label="Angka"
                                        class="form-group col-6"
                                        invalidmsg="Range tidak valid"
                                      >
                                        <input
                                          type="number"
                                          class="form-control"
                                          placeholder="Contoh '80'"
                                          v-model="this.edit_aspek.aspekkinerja['nilai'+ item +'_max']"
                                          required
                                          step="0.01"
                                          @change="validateEditAspek(item)"
                                          :class="{ 'is-invalid': this['error_aspek_'+ item] }"
                                          min="0"
                                        />
                                      </form-group>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <h4 class="text-lg mt-5">Aspek Kinerja</h4>
                              <div class="row w-100">
                                <form-group class="form-group col-4" label="Target">
                                  <input
                                    v-model="edit_aspek.target"
                                    type="number"
                                    class="form-control"
                                    placeholder="Contoh 200000"
                                    required
                                  >
                                </form-group>

                                <form-group class="form-group col-4" label="Satuan Target">
                                  <select class="form-select text-capitalize" aria-label="Satuan Target" v-model="edit_aspek.satuan" required>
                                    <option value="">- Pilih Satuan Target -</option>
                                    <!-- <option v-for="item in satuan_target" :key="item.value" :value="item.value">{{ item.label }}</option> -->
                                    <option v-for="item in list_satuan_target" :key="item.id" :value="item.nama_satuan">{{ item.nama_satuan }}</option>
                                  </select>
                                </form-group>

                                <form-group class="form-group col-4" label="Bobot">
                                  <div class="input-group">
                                    <input
                                      v-model="edit_aspek.bobot"
                                      type="number"
                                      class="form-control"
                                      placeholder="0.00"
                                      step=".01"
                                      required
                                    >
                                    <span class="input-group-text">%</span>
                                  </div>
                                </form-group>
                              </div>

                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" ref="closeModalEditAspek">Batalkan</button>
                              <button type="submit" class="btn btn-secondary">Simpan</button>
                            </div>
                          </form>
                        </div>
                      </div>

                      <!-- <pre>{{ additional_aspek_added }}</pre> -->
                      <template v-if="additional_aspek_added.length > 0">
                        <template
                          v-for="(item, i) in additional_aspek_added"
                          :key="item"
                        >
                          <hr />

                          <div class="mt-4 d-flex justify-content-between items-center">
                            <h4 class="text-lg">{{ item.title }}</h4>
                            <span>Total Bobot <strong>{{ sumBobotSubKpi(item.category) }}</strong></span>
                          </div>
                          <table class="table border rounded-2 rounded-top mt-4">
                            <thead>
                              <tr style="background-color: #E4E9EF;">
                                <th class="text-secondary text-xs">Sub KPI</th>
                                <th class="text-secondary text-xs" width="140px">Target</th>
                                <th class="text-secondary text-xs" width="140px">Satuan</th>
                                <th class="text-secondary text-xs" width="140px">Bobot</th>
                                <th class="text-secondary text-xs" width="40px"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item_sub, index) in item.category" :key="index">
                                <td class="font-weight-bolder p-4">{{ item_sub.nama_aspek_kpi }}</td>
                                <td class="py-4">
                                  <span v-if="item_sub?.satuan?.toLowerCase() === 'rupiah'">
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                      }).format(item_sub?.target || '0')
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        minimumFractionDigits: 0,
                                      }).format(item_sub?.target || '0')
                                    }} 
                                    <span class="text-capitalize">{{ (item_sub?.satuan?.toLowerCase() === 'persen' ? '%' : item_sub?.satuan) || '-' }}</span>
                                  </span>
                                </td>
                                <td class="py-4 text-capitalize">{{ item_sub?.satuan || '-' }}</td>
                                <!-- <td class="py-4 text-capitalize">{{ getSatuan(item_sub?.satuan) || '-' }}</td> -->
                                <td class="py-4">{{ item_sub.bobot }}%</td>
                                <td class="py-4">
                                  <div class="d-flex gap-1 justify-content-end">
                                    <button type="button" class="btn-action btn-action--icon-small btn-action--secondary" data-bs-toggle="modal" data-bs-target="#editAspekModal" @click="editAspek(item_sub, i, index, false)">
                                      <font-awesome-icon icon="fa-solid fa-pen" />
                                    </button>
                                    <button type="button" class="btn-action btn-action--icon-small btn-action--delete" @click="item?.category?.length > 1 ? additional_aspek_added[i].category.splice(index, 1) : deleteAdditionalAspekAdded(i)">
                                      <font-awesome-icon icon="fa-solid fa-trash" />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="mt-4 d-flex justify-content-end gap-4">
                            <button type="button" class="btn btn-outline-secondary" @click="deleteAdditionalAspekAdded(i)">Hapus</button>
                          </div>
                        </template>
                      </template>
                    
                    </template>

                    <template v-if="status === 'reject_by_admin'">

                      <hr class="mb-4">
                      <h5>KPI Tambahan Tersimpan</h5>
                    </template>

                    <!-- <pre>{{ detail_kpi_additional }}</pre> -->

                    <template v-for="(item, i) in detail_kpi_additional" :key="i">
                      <div class="d-flex justify-content-between items-center mt-4">
                        <h4 class="text-lg">{{ item?.title || '-' }}</h4>
                        <span>Total Bobot <strong>{{ sumBobotSubKpi(item?.kpi || []) }}</strong></span>
                      </div>
                      
                      <table class="table border rounded-2 rounded-top mt-2">
                        <thead>
                          <tr style="background-color: #E4E9EF;">
                            <th class="text-secondary text-xs">Sub KPI</th>
                            <th class="text-secondary text-xs" width="140px">Target</th>
                            <th class="text-secondary text-xs" width="140px">Satuan</th>
                            <th class="text-secondary text-xs" width="140px">Bobot</th>
                            <th class="text-secondary text-xs" width="40px" v-if="status === 'reject_by_admin'"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(sub, index) in item?.kpi" :key="index">
                            <td class="font-weight-bolder p-4">{{ sub?.title || '-' }}</td>
                            <td class="py-4">
                              <!-- {{
                                new Intl.NumberFormat('id-ID', {
                                  style: 'currency',
                                  currency: 'IDR',
                                  minimumFractionDigits: 0,
                                }).format(sub?.target || '0')
                              }} -->
                              <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                {{
                                  new Intl.NumberFormat('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                  }).format(sub?.target || '0')
                                }}
                              </span>
                              <span v-else>
                                {{
                                  new Intl.NumberFormat('id-ID', {
                                    minimumFractionDigits: 0,
                                  }).format(sub?.target || '0')
                                }} 
                                <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '-' }}</span>
                              </span>
                            </td>
                            <td class="py-4 text-capitalize">{{ sub?.satuan || '-' }}</td>
                            <!-- <td class="py-4 text-capitalize">{{ getSatuan(sub?.satuan) || '-' }}</td> -->
                            <td class="py-4">{{ sub?.bobot ? sub.bobot +'%' : '-' }}</td>
                            <td class="py-4" v-if="status === 'reject_by_admin'">
                              <div class="d-flex gap-1 justify-content-end">
                                <button type="button" class="btn-action btn-action--icon-small btn-action--secondary" data-bs-toggle="modal" data-bs-target="#editAspekModal" @click="editAspek(sub, i, index, true)">
                                  <font-awesome-icon icon="fa-solid fa-pen" />
                                </button>
                                <button type="button" class="btn-action btn-action--icon-small btn-action--delete" @click="item?.kpi?.length > 1 ? detail_kpi_additional[i].kpi.splice(index, 1) : deleteDetailKpiAdditional(i)">
                                  <font-awesome-icon icon="fa-solid fa-trash" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div
                        v-if="status === 'reject_by_admin'"
                        class="mt-4 d-flex justify-content-end gap-2"
                      >
                        <!-- <button
                          type="button"
                          class="btn-action btn-action--secondary"
                          @click="chooseKpiAdditional(i, item)"
                          :disabled="!item?.kpi || item?.kpi?.[0] === null"
                          data-bs-toggle="modal"
                          data-bs-target="#detailKpiModal"
                        >
                          Ubah
                        </button> -->
                        <button
                          type="button"
                          class="btn-action btn-action--delete"
                          @click="deleteDetailKpiAdditional(i)"
                        >
                          Hapus
                        </button>
                      </div>
                      <hr v-if="(i+1) !== detail_kpi_additional.length" class="mt-4 mb-4" />
                    </template>

                    <template v-if="$route.params?.id && detail_kpi_additional.length === 0">
                      <div class="d-flex justify-content-center items-center">
                        <!-- <h4 class="text-lg">{{ item?.title || '-' }}</h4> -->
                        <span>Tidak ada data aspek penilaian tambahan.</span>
                      </div>
                    </template>

                    <!-- Modal -->
                    <div class="modal fade" id="detailKpiModal" ref="detailKpiModal" tabindex="-1" aria-labelledby="detailKpiModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-xl">
                        <form @submit.prevent="updateSubKpiAdditional" class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="detailKpiModalLabel">{{ detail_kpi_additional_selected?.title || '-' }}</h5>
                            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                              <i class="fa fa-times cursor-pointer" aria-hidden="true"></i>
                            </button> -->

                            <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                              <font-awesome-icon icon="fa-solid fa-times" />
                            </span>
                          </div>
                          <div class="modal-body">
                            <div
                              v-for="(item, i) in detail_kpi_additional_selected?.kpi"
                              :key="item"
                              class="row"
                            >
                              <form-group class="form-group col-5" label="Nama Aspek">
                                <input type="text" class="form-control" placeholder="Nama aspek" :value="item?.title || '-'" readonly>
                              </form-group>
                              <form-group class="form-group col-3" label="Target">
                                <input type="number" class="form-control" placeholder="Target" v-model="detail_kpi_additional_selected.kpi[i].target" required>
                              </form-group>
                              <form-group class="form-group col-2" label="Satuan Target">
                                <select class="form-select text-capitalize" aria-label="Satuan Target" v-model="detail_kpi_additional_selected.kpi[i].satuan" required>
                                  <option value="">- Pilih Satuan Target -</option>
                                  <!-- <option v-for="item in satuan_target" :key="item.value" :value="item.value">{{ item.label }}</option> -->
                                  <option v-for="item in list_satuan_target" :key="item.id" :value="item.nama_satuan">{{ item.nama_satuan }}</option>
                                </select>
                              </form-group>

                              <form-group class="col-2 mb-4" label="Bobot">
                                <div class="input-group">
                                  <input type="number" class="form-control" placeholder="Bobot" aria-label="Bobot" :aria-describedby="'basic-addon2-detail-' + i" step=".01" v-model="detail_kpi_additional_selected.kpi[i].bobot" required>
                                  <span class="input-group-text" :id="'basic-addon2-detail-' + i">%</span>
                                </div>
                              </form-group>
                              <div class="p-2">
                                <div class="table-nilai">
                                  <div class="table-nilai__head">
                                    <div class="table-nilai__row table-nilai__row--head">
                                      <div class="table-nilai__col table-nilai__col--head">Nilai</div>
                                      <div class="table-nilai__col table-nilai__col--head">
                                        <div class="row">
                                          <div class="col-md-6">Operator</div>
                                          <div class="col-md-6">Angka Minimal</div>
                                        </div>
                                      </div>
                                      <div class="table-nilai__col table-nilai__col--head">
                                        <div class="row">
                                          <div class="col-md-6">Operator</div>
                                          <div class="col-md-6">Angka Maksimal</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="table-nilai__body">
                                    <div class="table-nilai__row" v-for="index in 5" :key="index">
                                      <div class="table-nilai__col">Nilai  {{ index }}</div>
                                      <div class="table-nilai__col">
                                        <div class="d-flex gap-2">
                                          <div class="col-md-6">
                                            <select class="form-control" name="" id="">
                                              <option value="">Pilih Operator</option>
                                            </select>
                                          </div>
                                          <div class="col-md-6">
                                            <input class="form-control" type="text" placeholder="Contoh: 80">
                                          </div>
                                        </div>
                                      </div>
                                      <div class="table-nilai__col">
                                        <div class="d-flex gap-2">
                                          <div class="col-md-6">
                                            <select class="form-control" name="" id="">
                                              <option value="">Pilih Operator</option>
                                            </select>
                                          </div>
                                          <div class="col-md-6">
                                            <input class="form-control" type="text" placeholder="Contoh: 80">
                                          </div>
                                        </div>
                                      </div>                                    
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn-action btn-action--secondary" data-bs-dismiss="modal" ref="detailKpiModalClose">Batalkan</button>
                            <button type="submit" class="btn-action btn-action--primary">Simpan</button>
                          </div>
                        </form>
                      </div>
                    </div>

                  </FieldsetComponent>
                </div>
              </tabbed-pane>
            </cards>

            <template v-if="!$route.params?.id || status === 'reject_by_admin'">
              <cards class="mb-4" :withmin="false">
                <hr />
                <div class="mt-4 d-flex justify-content-end gap-4">
                  <!-- <button type="button" class="btn btn-outline-secondary" @click="nextStep(1)">Batalkan</button> -->
                  <router-link :to="{ name: 'Assignment KPI Pegawai' }">
                    <button type="button" class="btn btn-outline-secondary">Batalkan</button>
                  </router-link>
                  <button v-if="!$route.params?.id" type="button" class="btn btn-secondary" @click="submitAssignment()">Kirim</button>
                  <button v-if="status === 'reject_by_admin'" type="button" class="btn btn-secondary" @click="updateAssignment()">Submit</button>
                </div>
              </cards>
              </template>
          </template>
        </div>

      </div>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
// import KpiCompetenciesApi from "@/repository/api/KpiCompetenciesApi";
// import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
// import ArgonInput from "@/components/ArgonInput.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import MetaSection from "@/components/MetaSection.vue";
// import GridRow from "@/components/grid/GridRow.vue";
// import GridCol from "@/components/grid/GridCol.vue";
// import EmployeeApi from '@/repository/api/EmployeeApi';
import TabbedPane from '@/components/TabbedPane.vue';
// import InputGroup from '@/components/InputGroup.vue';
// import InputForm from '@/components/InputForm.vue';
import FieldsetComponent from "@/components/FieldsetComponent.vue";

import AssignmentKpiApi from '@/repository/api/AssignmentKpiApi';
import KpiApi from '@/repository/api/KpiApi';
import KpiUsulanApi from '@/repository/api/KpiUsulanApi';
import EmployeeApi from '@/repository/api/EmployeeApi';
import KpiPeriodeApi from '@/repository/api/KpiPeriodeApi';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import SatuanTargetApi from '@/repository/api/SatuanTargetApi';
import { compareValues } from '@/utils/Extenstion';

export default {
  components: {
    // FieldsetComponent,
    Cards,
    FormGroup,
    // ArgonButton,
    // ArgonInput,
    ArgonAlert,
    MetaSection,
    // GridRow,
    // GridCol,
    TabbedPane,
    // InputGroup,
    // InputForm,
    FieldsetComponent,
  },
  data() {
    return {
      // employees: [],
      // showMenu: false,
      // data: {},
      // unitKerja: [
      //   {}
      // ],
      // employee: {},
      // selectedEmployeeAdd: "",
      // optionEmployee: [
      //   {
      //     id: "abc",
      //     text: "xyz",
      //   },
      // ],
      // jabatan: [],
      // optionUnitKerja: [],
      // optionJabatan: [],
      // myValue: '',
      // employeeKeyword: "",
      
      data: {},

      list_periode: [],
      periode_id: '',
      
      employees_list: [],
      loading_employees: false,
      employee_keyword: '',
      timer: null,

      // employee: {},
      employee_selected: {},

      detail_kpi_master: [],
      detail_kpi_additional: [],

      index_detail_kpi_additional_selected: null,
      detail_kpi_additional_selected: {},
      detail_kpi_additional_to_delete: [],

      step: 1,
      // step: 2,
      // satuan_target: ['rupiah','persen','pcs'],
      list_satuan_target: [],
      // old satuan target
      // satuan_target: [
      //   {
      //     value: 'rupiah',
      //     label: 'Rupiah'        
      //   },
      //   {
      //     value: 'persen',
      //     label: 'Persen/Hari/Skala Nilai'        
      //   },
      //   {
      //     value: 'pcs',
      //     label: 'Pcs'        
      //   }
      // ],
      kpi: [],
      kpi_selected: {},

      new_aspek: {
        nama_aspek_kpi: '',
        target: '',
        bobot: '',
        satuan: '',
        aspekkinerja: {
          nilai1_max: null,
          nilai1_max_operator: '<=',
          nilai1_min: null,
          nilai1_min_operator: '>=',
          nilai2_max: null,
          nilai2_max_operator: '<=',
          nilai2_min: null,
          nilai2_min_operator: '>=',
          nilai3_max: null,
          nilai3_max_operator: '<=',
          nilai3_min: null,
          nilai3_min_operator: '>=',
          nilai4_max: null,
          nilai4_max_operator: '<=',
          nilai4_min: null,
          nilai4_min_operator: '>=',
          nilai5_max: null,
          nilai5_max_operator: '<=',
          nilai5_min: null,
          nilai5_min_operator: '>=',
          status: '1',
        },
      },
      error_aspek_1: false,
      error_aspek_2: false,
      error_aspek_3: false,
      error_aspek_4: false,
      error_aspek_5: false,

      is_edit_aspek_saved: false,
      index_edit_kpi: null,
      index_edit_sub_kpi: null,
      edit_aspek: {
        // id: '',
        nama_aspek_kpi: '',
        target: '',
        bobot: '',
        satuan: '',
        aspekkinerja: {
          nilai1_max: null,
          nilai1_max_operator: '<=',
          nilai1_min: null,
          nilai1_min_operator: '>=',
          nilai2_max: null,
          nilai2_max_operator: '<=',
          nilai2_min: null,
          nilai2_min_operator: '>=',
          nilai3_max: null,
          nilai3_max_operator: '<=',
          nilai3_min: null,
          nilai3_min_operator: '>=',
          nilai4_max: null,
          nilai4_max_operator: '<=',
          nilai4_min: null,
          nilai4_min_operator: '>=',
          nilai5_max: null,
          nilai5_max_operator: '<=',
          nilai5_min: null,
          nilai5_min_operator: '>=',
          status: '1',
        },
      },
      error_edit_aspek_1: false,
      error_edit_aspek_2: false,
      error_edit_aspek_3: false,
      error_edit_aspek_4: false,
      error_edit_aspek_5: false,

      input_aspek_kpi: '',
      additional_aspek_temporary: null,
      perspektif_list: [
        'finance',
        'customer',
        'internal business process',
        'learn & growth',
      ],

      additional_aspek_added: [],
      thead: ['Nama Aspek','Target','Satuan Target','Bobot'],

      additional_aspek_data: {},
      additional_aspek_list: [],
      page: 1,
      limit: 10,
      additional_aspek_keyword: '',
      additional_aspek_list_unit_kerja: '',
      additional_aspek_unitkerja_id: '',
      // timer_additional_aspel: null,
      additional_aspek_loading: false,

      additional_aspek_selected: [],

      accept_additional_aspek: false,

      note: null,
    };
  },
  computed: {
    status() {
      return this.$route.params?.status;
    },
  },
  methods: {
    nextStep(step) {
      if (step === 1) {
        // this.keyword = '';
        this.employee_keyword = '';
        this.employees_list = [];
        this.getData();
      }
      this.step = step;
    },
    async getKpiPeriode() {
      await KpiPeriodeApi.getbyparam({
        status: 'active',
        limit: 100,
      })
        .then((response) => {
          this.list_periode = response?.data || [];
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getSatuanTarget() {
      await SatuanTargetApi.get()
        .then((response) => {
          // console.log(response?.data);
          this.list_satuan_target = response?.data || [];
        })
        .catch((err) => {
          console.log(err)
        });
    },

    addKpiTemporary() {
      this.additional_aspek_temporary = {
        title: this.input_aspek_kpi,
        jabatan_id: this.employee_selected.jabatan_id,
        type: 'additional',
        perspektif: '',
        category: [],
      };

      this.input_aspek_kpi = '';
    },

    deleteKpiTemporary() {
      this.additional_aspek_temporary = null;
    },

    deleteCategoryKpiTemporary(index) {
      if (this.additional_aspek_temporary.category?.[index]) {
        this.additional_aspek_temporary.category.splice(index, 1);
      }
    },

    async processKpiTemporary() {
      if (this.additional_aspek_temporary.category.length === 0) {
        this.$swal({
          icon: "error",
          title: "Aspek penilaian belum ditambahkan",
          text: "Silahkan cari atau buat aspek penilaian terlebih dahulu.",
        });

        return;
      }

      this.additional_aspek_added.push(this.additional_aspek_temporary);
      this.additional_aspek_temporary = null;
    },

    addSearchAspek() {
      if (this.additional_aspek_selected.length > 0) {
        this.additional_aspek_selected.forEach(item => {
          // if (item?.aspekkinerja) {
          //   item?.aspekkinerja.forEach(item_sub => {
          //     let nilai = JSON.parse(JSON.stringify(item_sub));

          //     console.log(nilai)

          //     delete nilai.id;
          //     delete nilai.name;
          //     delete nilai.created_at;
          //     delete nilai.updated_at;

          //     this.additional_aspek_temporary.category.push({
          //       nama_aspek_kpi: item_sub?.name,
          //       bobot: item?.bobot?.toString(),
          //       satuan: item?.satuan,
          //       target: item?.target?.toString(),
          //       aspekkinerja: nilai,
          //       subkpi_id: item?.subkpi_id,
          //       aspekkinerja_id: item?.aspekkinerja_id,
          //     });
              
          //   });
            
          //   console.log(this.additional_aspek_temporary)
          // }

          let nilai = JSON.parse(JSON.stringify(item?.detail_aspek_kinerja));

          delete nilai.id;
          delete nilai.name;
          delete nilai.created_at;
          delete nilai.updated_at;
          delete nilai.is_delete;
          delete nilai.delete_by;
          delete nilai.delete_date;

          this.additional_aspek_temporary.category.push({
            nama_aspek_kpi: item?.detail_aspek_kinerja?.name,
            bobot: item?.bobot?.toString(),
            satuan: item?.satuan,
            target: item?.target?.toString(),
            aspekkinerja: nilai,
            subkpi_id: item?.subkpi_id,
            aspekkinerja_id: item?.aspekkinerja_id,
          });
        });
      }
    },

    addNewAspek() {
      if (this.error_aspek_1 || this.error_aspek_2 || this.error_aspek_3 || this.error_aspek_4 || this.error_aspek_5) {
        this.$swal({
          icon: "error",
          title: "Aspek penilaian salah",
          text: "Cek kembali data aspek KPI.",
        });
        return;
      }
      
      this.additional_aspek_temporary.category.push(this.new_aspek);

      this.new_aspek = {
        nama_aspek_kpi: '',
        target: '',
        bobot: '',
        satuan: '',
        aspekkinerja: {
          nilai1_max: null,
          nilai1_max_operator: '<=',
          nilai1_min: null,
          nilai1_min_operator: '>=',
          nilai2_max: null,
          nilai2_max_operator: '<=',
          nilai2_min: null,
          nilai2_min_operator: '>=',
          nilai3_max: null,
          nilai3_max_operator: '<=',
          nilai3_min: null,
          nilai3_min_operator: '>=',
          nilai4_max: null,
          nilai4_max_operator: '<=',
          nilai4_min: null,
          nilai4_min_operator: '>=',
          nilai5_max: null,
          nilai5_max_operator: '<=',
          nilai5_min: null,
          nilai5_min_operator: '>=',
          status: '1',
        },
      };

      // close modal
      this.$refs.closeModalAddNewAspek.click();
    },
    validateAspek(nilai) {
      let result = true;

      try {
        if (
          compareValues(this.new_aspek.aspekkinerja['nilai'+ nilai +'_min_operator'], this.new_aspek.aspekkinerja['nilai'+ nilai +'_max'], this.new_aspek.aspekkinerja['nilai'+ nilai +'_min']) &&
          compareValues(this.new_aspek.aspekkinerja['nilai'+ nilai +'_max_operator'], this.new_aspek.aspekkinerja['nilai'+ nilai +'_min'], this.new_aspek.aspekkinerja['nilai'+ nilai +'_max'])
        ) {
          result = false;
        }
      } catch (error) {
        result = true;
      }

      this['error_aspek_'+ nilai] = result;
    },

    editAspek(sub, index_kpi, index_sub_kpi, is_from_saved = false) {
      this.is_edit_aspek_saved = is_from_saved;
      this.index_edit_kpi = index_kpi;
      this.index_edit_sub_kpi = index_sub_kpi;

      // reset first
      this.edit_aspek = {
        nama_aspek_kpi: '',
        target: '',
        bobot: '',
        satuan: '',
        aspekkinerja: {
          // id: '',
          nilai1_max: null,
          nilai1_max_operator: '<=',
          nilai1_min: null,
          nilai1_min_operator: '>=',
          nilai2_max: null,
          nilai2_max_operator: '<=',
          nilai2_min: null,
          nilai2_min_operator: '>=',
          nilai3_max: null,
          nilai3_max_operator: '<=',
          nilai3_min: null,
          nilai3_min_operator: '>=',
          nilai4_max: null,
          nilai4_max_operator: '<=',
          nilai4_min: null,
          nilai4_min_operator: '>=',
          nilai5_max: null,
          nilai5_max_operator: '<=',
          nilai5_min: null,
          nilai5_min_operator: '>=',
          status: '1',
        },
      };

      // check & set from saved or new
      if (is_from_saved) {
        this.edit_aspek = {
          nama_aspek_kpi: sub?.title || '',
          target: sub?.target || '',
          bobot: sub?.bobot || '',
          satuan: sub?.satuan || '',
          aspekkinerja: {
            // id: sub?.id || '',
            nilai1_max: sub?.aspek_kinerja?.nilai1_max || null,
            nilai1_max_operator: sub?.aspek_kinerja?.nilai1_max_operator || '<=',
            nilai1_min: sub?.aspek_kinerja?.nilai1_min || null,
            nilai1_min_operator: sub?.aspek_kinerja?.nilai1_min_operator || '>=',
            nilai2_max: sub?.aspek_kinerja?.nilai2_max || null,
            nilai2_max_operator: sub?.aspek_kinerja?.nilai2_max_operator || '<=',
            nilai2_min: sub?.aspek_kinerja?.nilai2_min || null,
            nilai2_min_operator: sub?.aspek_kinerja?.nilai2_min_operator || '>=',
            nilai3_max: sub?.aspek_kinerja?.nilai3_max || null,
            nilai3_max_operator: sub?.aspek_kinerja?.nilai3_max_operator || '<=',
            nilai3_min: sub?.aspek_kinerja?.nilai3_min || null,
            nilai3_min_operator: sub?.aspek_kinerja?.nilai3_min_operator || '>=',
            nilai4_max: sub?.aspek_kinerja?.nilai4_max || null,
            nilai4_max_operator: sub?.aspek_kinerja?.nilai4_max_operator || '<=',
            nilai4_min: sub?.aspek_kinerja?.nilai4_min || null,
            nilai4_min_operator: sub?.aspek_kinerja?.nilai4_min_operator || '>=',
            nilai5_max: sub?.aspek_kinerja?.nilai5_max || null,
            nilai5_max_operator: sub?.aspek_kinerja?.nilai5_max_operator || '<=',
            nilai5_min: sub?.aspek_kinerja?.nilai5_min || null,
            nilai5_min_operator: sub?.aspek_kinerja?.nilai5_min_operator || '>=',
            status: sub?.status === 'active' ? '1' : '0',
          },
        };
        
      } else {
        this.edit_aspek = {
          nama_aspek_kpi: sub?.nama_aspek_kpi || '',
          target: sub?.target || '',
          bobot: sub?.bobot || '',
          satuan: sub?.satuan || '',
          aspekkinerja: {
            // id: '',
            nilai1_max: sub?.aspekkinerja?.nilai1_max || null,
            nilai1_max_operator: sub?.aspekkinerja?.nilai1_max_operator || '<=',
            nilai1_min: sub?.aspekkinerja?.nilai1_min || null,
            nilai1_min_operator: sub?.aspekkinerja?.nilai1_min_operator || '>=',
            nilai2_max: sub?.aspekkinerja?.nilai2_max || null,
            nilai2_max_operator: sub?.aspekkinerja?.nilai2_max_operator || '<=',
            nilai2_min: sub?.aspekkinerja?.nilai2_min || null,
            nilai2_min_operator: sub?.aspekkinerja?.nilai2_min_operator || '>=',
            nilai3_max: sub?.aspekkinerja?.nilai3_max || null,
            nilai3_max_operator: sub?.aspekkinerja?.nilai3_max_operator || '<=',
            nilai3_min: sub?.aspekkinerja?.nilai3_min || null,
            nilai3_min_operator: sub?.aspekkinerja?.nilai3_min_operator || '>=',
            nilai4_max: sub?.aspekkinerja?.nilai4_max || null,
            nilai4_max_operator: sub?.aspekkinerja?.nilai4_max_operator || '<=',
            nilai4_min: sub?.aspekkinerja?.nilai4_min || null,
            nilai4_min_operator: sub?.aspekkinerja?.nilai4_min_operator || '>=',
            nilai5_max: sub?.aspekkinerja?.nilai5_max || null,
            nilai5_max_operator: sub?.aspekkinerja?.nilai5_max_operator || '<=',
            nilai5_min: sub?.aspekkinerja?.nilai5_min || null,
            nilai5_min_operator: sub?.aspekkinerja?.nilai5_min_operator || '>=',
            status: sub?.aspekkinerja?.status || '1',
          },
        };
      }

      console.log(this.edit_aspek);
    },

    updatEditAspek() {
      if (this.is_edit_aspek_saved) {
        // saved
        // detail_kpi_additional.kpi

        if (this.detail_kpi_additional?.[this.index_edit_kpi]?.kpi?.[this.index_edit_sub_kpi]) {
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].title = this.edit_aspek.nama_aspek_kpi;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].target = this.edit_aspek.target;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].bobot = this.edit_aspek.bobot;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].satuan = this.edit_aspek.satuan;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.nilai1_max = this.edit_aspek.aspekkinerja.nilai1_max;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.nilai1_max_operator = this.edit_aspek.aspekkinerja.nilai1_max_operator;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.nilai2_max = this.edit_aspek.aspekkinerja.nilai2_max;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.nilai2_max_operator = this.edit_aspek.aspekkinerja.nilai2_max_operator;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.nilai3_max = this.edit_aspek.aspekkinerja.nilai3_max;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.nilai3_max_operator = this.edit_aspek.aspekkinerja.nilai3_max_operator;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.nilai4_max = this.edit_aspek.aspekkinerja.nilai4_max;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.nilai4_max_operator = this.edit_aspek.aspekkinerja.nilai4_max_operator;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.nilai5_max = this.edit_aspek.aspekkinerja.nilai5_max;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.nilai5_max_operator = this.edit_aspek.aspekkinerja.nilai5_max_operator;
          this.detail_kpi_additional[this.index_edit_kpi].kpi[this.index_edit_sub_kpi].aspek_kinerja.status = this.edit_aspek.aspekkinerja.status;
        }
        
      } else {
        // added
        // additional_aspek_added.category

        if (this.additional_aspek_added?.[this.index_edit_kpi]?.category?.[this.index_edit_sub_kpi]) {
          this.additional_aspek_added[this.index_edit_kpi].category[this.index_edit_sub_kpi] = this.edit_aspek;
        }
      }

      // close modal
      this.$refs.closeModalEditAspek.click();
    },

    validateEditAspek(nilai) {
      let result = true;

      try {
        if (
          compareValues(this.edit_aspek.aspekkinerja['nilai'+ nilai +'_min_operator'], this.edit_aspek.aspekkinerja['nilai'+ nilai +'_max'], this.edit_aspek.aspekkinerja['nilai'+ nilai +'_min']) &&
          compareValues(this.edit_aspek.aspekkinerja['nilai'+ nilai +'_max_operator'], this.edit_aspek.aspekkinerja['nilai'+ nilai +'_min'], this.edit_aspek.aspekkinerja['nilai'+ nilai +'_max'])
        ) {
          result = false;
        }
      } catch (error) {
        result = true;
      }

      this['error_aspek_'+ nilai] = result;
    },

    deleteAdditionalAspekAdded(index) {
      this.additional_aspek_added.splice(index, 1);
    },

    collectAdditionalAspekFromChild(item_child) {
      if (!item_child?.aspekpenilaian?.length) return;

      item_child.aspekpenilaian.forEach(item_child_aspekpenilaian => {
        if (item_child_aspekpenilaian?.aspekkinerja?.length) {
          let item_additional = item_child_aspekpenilaian;
          item_additional.subkpi_id = item_child.id;
          item_additional.aspekkinerja_id = item_child_aspekpenilaian?.aspekkinerja?.[0]?.id;
          this.additional_aspek_list.push(item_additional);
        }
      });
    },
    collectAdditionalAspek(data) {
      if (!data?.length) return;

      data.forEach(item => {
        if (item?.child?.length) {
          item.child.forEach(item_child => {
            this.collectAdditionalAspekFromChild(item_child);
          });
        }
      });
    },
    async getListAdditionalAspek() {
      this.additional_aspek_loading = true;
      this.additional_aspek_list =  [];

      await KpiApi.getbyparam({
        type: 'additional',
        unique_aspek_kinerja: true,
        keyword_sub: this.additional_aspek_keyword,
        unitkerja_id: this.additional_aspek_unitkerja_id,
      })
        .then((resp) => {
          this.additional_aspek_data = resp;
          this.collectAdditionalAspek(resp?.data);
        })
        .catch((err) => {
          console.log(err)
        })

      this.additional_aspek_loading = false;
    },
    async modalSearchAspek(isOpen = false) {
      if (isOpen) {
        this.page = 1;
        this.limit = 10;
        this.additional_aspek_keyword = '';
        // this.additional_aspek_unitkerja_id = '';
        this.additional_aspek_unitkerja_id = this.employee_selected?.unitkerja?.id || '';
        this.additional_aspek_list = [];
        this.additional_aspek_data = {};
        this.additional_aspek_selected = [];
        
        await this.getListAdditionalAspek();
        await this.getUnitKerja();
      }
    },

    async getUnitKerja() {
      this.$store.state.loading = true;
      // await UnitKerjaApi.get()
      await UnitKerjaApi.getbyparam({
        page: 'all',
        status: 'active',
      })
        .then((response) => {
          this.additional_aspek_list_unit_kerja = response?.data;
        }).catch(() => {
          this.unitkerja = [];
        });
      this.$store.state.loading = false;
    },

    async searchKeywordAdditionalAspek() {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        if (this.additional_aspek_keyword.length > 0) {
          // await this.getListAdditionalAspek();

          this.page = 1;
            this.limit = 10;
            // this.additional_aspek_keyword = '';
            this.additional_aspek_list = [];
            this.additional_aspek_data = {};
            this.additional_aspek_selected = [];
            
            await this.getListAdditionalAspek();
        } else {
          await this.modalSearchAspek(true);
        }
      }, 1000)
      
    },

    chooseSearchAspek(value) {
      if (this.additional_aspek_selected.includes(value)) {
        let index = this.additional_aspek_selected.indexOf(value);
        if (index > -1) this.additional_aspek_selected.splice(index, 1);
      } else {
        this.additional_aspek_selected.push(value);
      }
    },

    async getData() {
      this.data = [];
      this.employee_selected = {};
      this.periode_id = this.$route.params?.periode_id || '';

      // console.log('this.$route.params?.periode_id', this.$route.params?.periode_id);

      this.$store.state.loading = true;
      await this.getKpiPeriode();
      await this.getSatuanTarget();

      if (this.$route.params?.id) {
        await AssignmentKpiApi.getDetail({
          employee: this.$route.params.id,
          periode_id: this.periode_id,
        })
          .then((resp) => {
            // console.log(resp?.data)
            // this.data = resp.data;
            this.employee_selected = resp?.data?.employee || null;
            this.detail_kpi_master = resp?.data?.master || null;
            this.detail_kpi_additional = resp?.data?.additional || null;
            this.note = resp?.data?.catatan || null;
          })
          .catch((err) => {
            console.log(err)
          });

        this.step = 2;
      }

      this.$store.state.loading = false;
    },

    async getEmployees() {
      this.loading_employees = true;
      // await EmployeeApi.getByParam({ keyword: this.employee_keyword, page: 1 })
      await EmployeeApi.getByKeyword(this.employee_keyword)
        .then((resp) => {
          // console.log(resp?.data)
          this.employees_list = resp?.data
        })
        .catch((err) => {
          console.log(err)
        });
      this.loading_employees = false;
    },

    async searchKeyword() {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        if (this.employee_keyword.length > 0) {
          await this.getEmployees();
        } else {
          this.employees_list = [];
        }
      }, 1000)
    },

    async getKpiPerUnit() {
      this.$store.state.loading = true;
      await AssignmentKpiApi.getKpiPerUnit({
        employee: this.employee_selected.id,
        // unitkerja: this.employee_selected.unitkerja_id,
        jabatan_id: this.employee_selected.jabatan_id,
      })
        .then((resp) => {
          // console.log(resp?.data)
          this.kpi = resp?.data?.[0]?.kpi;
        })
        .catch((err) => {
          console.log(err)
        })
      this.$store.state.loading = false;
    },

    async chooseEmployee(data) {
      this.employee_selected = data;
      this.nextStep(2);

      await this.getKpiPerUnit();
    },

    sumBobotSubKpi(data) {
      data = data.map((item) => Number.parseFloat(item?.bobot || 0));
      data = data.reduce((a, b) => a + b, 0);
      return data;
    },
    
    async chooseKpi(data) {
      this.kpi_selected = data;
    },

    async updateSubKpi() {
      this.$store.state.loading = true;

      try {
        for (let index = 0; index < this.kpi_selected.child.length; index++) {
          // await AssignmentKpiApi.updateSubKpi(this.kpi_selected.child[index].id, {
          await KpiApi.update(this.kpi_selected.child[index].id, {
            target: this.kpi_selected.child[index].target,
            satuan: this.kpi_selected.child[index].satuan,
            bobot: this.kpi_selected.child[index].bobot,
          })
        }
        
        await this.getKpiPerUnit();

        // close modal
        this.$refs.kpiModalClose.click();
        this.$store.state.loading = false;
  
      } catch (err) {
        console.log(err)
        
        this.$store.state.loading = false;
      }
    },
    
    async chooseKpiAdditional(index, data) {
      this.detail_kpi_additional_selected = JSON.parse(JSON.stringify(data));
      this.index_detail_kpi_additional_selected = index;
    },

    async updateSubKpiAdditional() {
      this.detail_kpi_additional[this.index_detail_kpi_additional_selected] = this.detail_kpi_additional_selected;
      this.detail_kpi_additional_selected = {};
      this.index_detail_kpi_additional_selected = null;
      this.$refs.detailKpiModalClose.click();
    },

    deleteDetailKpiAdditional(index) {
      this.$swal({
        icon: "warning",
        title: "Hapus KPI tambahan yang telah tersimpan?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.detail_kpi_additional_to_delete.push(JSON.parse(JSON.stringify(this.detail_kpi_additional[index])));
          this.detail_kpi_additional.splice(index, 1);
        }
      })
    },

    collectSelectedKpi() {
      const kpi = [];
      this.kpi.forEach(item => {
        if (item?.child && item?.child?.[0] !== null) {
          item.child.forEach(item_sub => {
            if (item_sub) {
              kpi.push({
                subkpi_id: item_sub.id,
                bobot: item_sub.bobot.toString(),
                target: item_sub.target.toString(),

                // temporary, need update
                status: 'publish',
              });
            }
          });
        }
      });
      return kpi;
    },
    remapAdditionalAspek(additional_aspek) {
      return additional_aspek.map((item) => {
        item.category.map((item_sub) => {
          item_sub.target = item_sub.target.toString();
          item_sub.bobot = item_sub.bobot.toString();

          Object.keys(item_sub.aspekkinerja).forEach((e) => {
            item_sub.aspekkinerja[e] = item_sub.aspekkinerja[e].toString();
          });

          return item_sub;
        })
        return item;
      });
    },
    collectAssignUsulanData(response_create_usulan) {
      const data_create_assign_usulan = [];
      if (!response_create_usulan) return data_create_assign_usulan;

      for (let i = 0; i < response_create_usulan.length; i++) {
        if (response_create_usulan[i].child) {
          for (let j = 0; j < response_create_usulan[i].child.length; j++) {
            const item = response_create_usulan[i].child[j];

            data_create_assign_usulan.push({
              subkpi_id: item.id,
              bobot: item.aspekpenilaian[0].bobot.toString(),
              target: item.aspekpenilaian[0].target.toString(),
              status: 'publish',
            })
          }
        }
      }
      return data_create_assign_usulan;
    },
    async submitAdditionalAspek() {
      if (!this.additional_aspek_added?.length) return;

      let additional_aspek = JSON.parse(JSON.stringify(this.additional_aspek_added));
      additional_aspek = this.remapAdditionalAspek(additional_aspek);

      const response_create_usulan = [];
      for (let index = 0; index < additional_aspek.length; index++) {
        additional_aspek[index].category = JSON.stringify(additional_aspek[index].category);

        const resp = await KpiApi.create(additional_aspek[index]).catch((err) => {
          console.log(err)
          throw err;
        });
        if (resp?.data) response_create_usulan.push(resp?.data);
      }

      const data_create_assign_usulan = this.collectAssignUsulanData(response_create_usulan);

      if (data_create_assign_usulan.length > 0) {
        await KpiUsulanApi.create({
          employee_id: this.employee_selected.id,
          kpi: JSON.stringify(data_create_assign_usulan),
          periode_id: this.periode_id,
        }).catch((err) => {
          console.log(err)
          throw err;
        });
      }
    },
    async submitAssignment() {
      // console.log('submitAssignment()')
      // console.log(this.employee_selected)
      // console.log(this.kpi)

      if (this.periode_id === '') {
        this.$swal({
          icon: "error",
          title: "Periode Belum Dipilih",
          text: "Pilih periode terlebih dahulu.",
        })
        return;
      }

      if (this.additional_aspek_temporary !== null) {
        this.$swal({
          icon: "warning",
          title: "Aspek Penilaian Kinerja Tambahan",
          text: "Terdapat aspek penilaian kinerja tambahan yg belum diproses, mohon selesaikan proses terlebih dahulu.",
        })
        return;
      }

      if (this.additional_aspek_added.length > 0 && this.accept_additional_aspek === false) {
        this.$swal({
          icon: "warning",
          title: "Aspek Penilaian Kinerja Tambahan",
          text: "Ketentuan aspek penilaian kinerja tambahan belum disetujui, mohon baca & setujui ketentuan terlebih dahulu.",
        });
        return;
      }

      this.$swal({
        icon: "info",
        title: "Tambah Assignment KPI Pegawai?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
    
          try {
            const kpi = this.collectSelectedKpi();
      
            const params = {
              employee_id: this.employee_selected.id,
              kpi: JSON.stringify(kpi),
              periode_id: this.periode_id,
            };
      
            await AssignmentKpiApi.create(params)
              .then(() => {
                // console.log(resp)
                // this.$router.push({ name: 'Assignment KPI Pegawai' });
              })
              .catch((err) => {
                console.log(err);
                throw err;
              });
      
            // console.log(this.additional_aspek_added)
      
            if (this.additional_aspek_added) {
              await this.submitAdditionalAspek();
            }
      
            this.$store.state.loading = false;
            this.$swal({
              icon: "success",
              title: 'Data berhasil dikirim.',
            });
            this.$router.push({ name: 'Assignment KPI Pegawai' });
            
          } catch (error) {
            console.log(error)
            this.$store.state.loading = false;

            // if (error !== 'failed_handled') {
            //   this.$swal({
            //     icon: "error",
            //     title: 'Something wrong, please try again.',
            //   });
            // }

            this.$swal({
              icon: "error",
              // title: "Aspek Penilaian Kinerja Tambahan",
              title: error?.response?.data?.message || 'Something wrong, please try again!',
            });
          }
        }
      });
    },

    async updateDetailKpiAdditional() {
      for (let i = 0; i < this.detail_kpi_additional.length; i++) {
        const item = this.detail_kpi_additional[i];

        if (item?.kpi?.length > 0) {
          for (let j = 0; j < item.kpi.length; j++) {
            const item_sub = item.kpi[j];

            const aspek_kinerja = item_sub.aspek_kinerja;

            // delete aspek_kinerja.id;
            // delete aspek_kinerja.name;
            delete aspek_kinerja.status;
            delete aspek_kinerja.created_at;
            delete aspek_kinerja.updated_at;
            delete aspek_kinerja.is_delete;
            delete aspek_kinerja.delete_by;
            delete aspek_kinerja.delete_date;

            await KpiApi.updateAdditionalNew(item_sub.kpiaspekpenilaianassignment_id, {
              target: item_sub.target,
              satuan: item_sub.satuan,
              bobot: item_sub.bobot,
              aspek_kinerja: JSON.stringify(aspek_kinerja),
            })
              .then((resp) => {
                console.log(resp)
              })
              .catch((err) => {
                console.log(err)
                throw err;
              });
          }

          await KpiApi.udateStatusAdditionalNew({
            assignment: JSON.stringify(item.kpi.map(item_map => item_map.kpiaspekpenilaianassignment_id)),
          })
            .then((resp) => {
              console.log(resp)
            })
            .catch((err) => {
              console.log(err)
              throw err;
            });
        }
      }
    },
    async submitDeletedDetailKpiAdditional() {
      for (let index = 0; index < this.detail_kpi_additional_to_delete.length; index++) {
        const item = this.detail_kpi_additional_to_delete[index];

        await KpiApi.deleteAdditionalNew({
          id: item.id,
          kpiaspekpenilaianassignment_id: JSON.stringify(item.kpi.map(item_sub => item_sub.kpiaspekpenilaianassignment_id)),
        })
          .then((resp) => {
            console.log(resp?.data)
          })
          .catch((err) => {
            console.log(err)
            throw err;
          });
      }
    },

    async updateAssignment() {
      // console.log('updateAssignment()')
      // console.log('additional_aspek_added', this.additional_aspek_added)
      // console.log('detail_kpi_additional', this.detail_kpi_additional)
      // console.log('detail_kpi_additional_to_delete', this.detail_kpi_additional_to_delete)
      // console.log(this.kpi) 

      if (this.additional_aspek_temporary !== null) {
        this.$swal({
          icon: "warning",
          title: "Aspek Penilaian Kinerja Tambahan",
          text: "Terdapat aspek penilaian kinerja tambahan yg belum diproses, mohon selesaikan proses terlebih dahulu.",
        })
        return;
      }

      // return;

      // eslint-disable-next-line no-unreachable
      this.$swal({
        icon: "info",
        title: "Ubah Assignment KPI Pegawai?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
    
          try {
            // console.log(this.additional_aspek_added)
      
            // if any new additional aspek, create
            if (this.additional_aspek_added.length > 0) {
              await this.submitAdditionalAspek();
            }

            if (this.detail_kpi_additional.length > 0) {
              await this.updateDetailKpiAdditional();
            }

            if (this.detail_kpi_additional_to_delete.length > 0) {
              await this.submitDeletedDetailKpiAdditional();
            }
      
            this.$store.state.loading = false;
            this.$swal({
              icon: "success",
              title: 'Data berhasil perbarui.',
            });
            this.$router.push({ name: 'Assignment KPI Pegawai' });
            
          } catch (error) {
            console.log(error)
            this.$store.state.loading = false;

            // if (error !== 'failed_handled') {
            //   this.$swal({
            //     icon: "error",
            //     title: 'Something wrong, please try again.',
            //   });
            // }

            this.$swal({
              icon: "error",
              // title: "Aspek Penilaian Kinerja Tambahan",
              title: error?.response?.data?.message || 'Something wrong, please try again!',
            });
          }
        }
      });
    },
    
    // old satuan
    // getSatuan(satuan) {
    //   let result = null
    //   try {
    //     result = this.satuan_target.find(({ value }) => value === satuan);
    //     result = result.label
    //   } catch (error) {
    //     result = satuan
    //   }
    //   return result
    // }
  },
  async mounted() {
    this.getData();
  },
};
</script>
